import React__default from 'react';
import { V as ValidationLine } from '../FormGroup/ValidationLine-DjKYKrQz.js';
import { c as InputValidationMessage } from './Input.styles-DOCgF0N8.js';

const ValidationMessage = ({
  value,
  messageId,
  message,
  messageE2EId,
  statusType
}) => /*#__PURE__*/React__default.createElement(ValidationLine, {
  role: "alert",
  "aria-live": "assertive",
  id: messageId
}, typeof message === 'function' ? message(value) : /*#__PURE__*/React__default.createElement(InputValidationMessage, {
  variant: statusType,
  message: message,
  "data-e2e-id": messageE2EId
}));

export { ValidationMessage as V };
//# sourceMappingURL=ValidationMessage-Hl9UdKeI.js.map
